import React, { FC, useState } from 'react';
import { useOrganizationQuery } from '../../../../../api/queries/use-organization-query';
import { Formula } from '../../../../../types';
import { OrgQueryKeys } from '../../../../../api/config';
import { AgisticsSelect } from '../../../../shared/agistics-select';
import { useDraftLoadContext } from '../../../hooks/draft-load-context';
import { L } from 'harmony-language';
import { Button } from '@mui/material';

interface EditableLoadFormulaProps {
    onBack: () => void;
}

export const EditableLoadFormula: FC<EditableLoadFormulaProps> = (props) => {
    const { onBack } = props;
    const { editedLoad, onEditedLoadChanged } = useDraftLoadContext();
    const { data: formulas = [] } = useOrganizationQuery<Formula[]>(OrgQueryKeys.formulas);
    const [selectedFormula, setSelectedFormula] = useState(-1);

    const formulaItems = formulas.map(formula => ({
        id: formula.id,
        value: formula.name,
    }));

    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '1rem' }}>
            <Button
                variant='contained'
                color='primary'
                onClick={onBack}
            >
                {L.back()}
            </Button>
            {formulaItems.length > 0 && <div style={{ width: '20rem' }}>
                <AgisticsSelect
                    item={selectedFormula}
                    items={formulaItems}
                    onChange={(formulaId) => {
                        setSelectedFormula(formulaId);

                        const formula = formulas.find(x => x.id === formulaId);
                        if (formula) {
                            const newStops = editedLoad.stops.map(x => {
                                return {
                                    ...x,
                                    productionPlan: formula.name,
                                }
                            });

                            onEditedLoadChanged({
                                stops: newStops,
                            });
                        } else {
                            onEditedLoadChanged({
                                stops: editedLoad.stops.map(x => ({ ...x, productionPlan: null })),
                            });
                        }
                    }}
                    label={L.formula()}
                    showNone={true}
                />
            </div>}
        </div>
    );
};
